// extracted by mini-css-extract-plugin
export default {"unChecked":"checkbox__unChecked--UF6FH","checked":"checkbox__checked--oPzyK","unveil":"checkbox__unveil--gFt86"};